// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"k_-z"};